import { TUserInfo } from '@/api'
import Cookies from 'js-cookie'
import sensors from 'sa-sdk-javascript'

export interface IResourceDisplay {
  top_recommended_display?: string
  rank_display?: string
  recommended_display?: string
  resource_id?: string
  cover_recommend_display?: boolean
  grid_display?: boolean
  exit_recommend_display?: boolean
  booklist_display?: boolean
  thread_display?: boolean
  book_review_show?: number
  finish_recommend_display?: boolean
  subpackage_finish_recommend_display?: boolean
  resource_tag_id?: string
  resource_genre?: string
}

/**
 * @params button 1点击模块，2点击read、start reading
 */
export interface IResourceClick {
  top_recommended_click?: string
  rank_click?: string
  recommended_click?: string
  resource_id?: string
  button?: string
  rank_book_click?: string
  cover_recommend_click?: number
  grid_click?: boolean
  exit_recommend_click?: number
  booklist_enter?: string
  thread_enter?: string
  book_review_enter?: string
  finish_recommend_click?: number
  resource_tag_id?: string
  resource_genre?: string
}

const PACKAGE_PREFIX_TRANSFER_COOKIE_KEY = 'pkg_package_prefix_val'
const MTCID_TRANSFER_COOKIE_KEY = 'pkg_mtcid_val'
const MASTER_COOKIE_OPTIONS = {
  domain: '.mespery.com',
  path: '/',
}

const getAuthSourceProfile = () => {
  const fromPackagePrefix = Cookies.get(PACKAGE_PREFIX_TRANSFER_COOKIE_KEY) || ''
  const mtcid = Cookies.get(MTCID_TRANSFER_COOKIE_KEY) || ''

  return {
    ...(fromPackagePrefix ? { from_package_prefix: fromPackagePrefix, ad_platform: 'fb' } : {}),
    ...(mtcid ? { mtcid, ad_platform: 'fb' } : {}),
  }
}

const clearAuthSourceProfileCookies = () => {
  Cookies.remove(PACKAGE_PREFIX_TRANSFER_COOKIE_KEY, MASTER_COOKIE_OPTIONS)
  Cookies.remove(MTCID_TRANSFER_COOKIE_KEY, MASTER_COOKIE_OPTIONS)
}

export const handleLoginTrack = async (userData: TUserInfo) => {
  sensors.login(userData.id)

  const authSourceProfile = getAuthSourceProfile()
  if (Object.keys(authSourceProfile).length) {
    sensors.setOnceProfile(authSourceProfile)
    clearAuthSourceProfileCookies()
  }

  sensors.track('user_login', {
    gender: userData.gender,
    register_type: userData.register_type,
    created_at: userData.created_at,
    author_id: userData.author_id,
  })
}

export const handleClickFollowTrack = (follow_id: string, be_follow_id: string, from_follow: string) => {
  sensors.track('click_follow', {
    follow_id,
    from_follow,
    be_follow_id,
  })
}

export const handleClickMessageTrack = () => {
  sensors.track('click_message')
}

export const handleImClickTrack = (from: string, contact_uid: string) => {
  sensors.track('im_click', {
    from,
    contact_uid,
  })
}

export const handletaskPageEntryTrack = (task_entry_method: number) => {
  sensors.track('task_page_entry', {
    task_entry_method,
  })
}

export const handleSearchKeywordTrack = (keyword: string, result_count: number, search_type: string) => {
  sensors.track('search_keyword', {
    keyword,
    result_count,
    search_type,
  })
}

export const handleSearchInputTrack = () => {
  sensors.track('search_input')
}

export interface IDetailView {
  resource_type: number | ''
  resource_id: string
  resource_tag_id: string | ''
  /**
   * 1.顶部推荐位
   * 2.排行榜
   * 3.首页底部书籍网络
   * 4.他人推荐位
   * 5.阅读全本完成推荐位
   * 6.书封页封面资源位
   * 7.退出阅读器推荐位
   * 8.书单推荐位
   * 9.书评推荐位
   * 10.帖子推荐位
   * 11.搜索栏
   */
  cover_from: number | ''
  resource_genre: string
}
export const handleDetailViewTrack = (eventData: IDetailView) => {
  sensors.track('detail_view', eventData)
}

export const handleContentViewTrack = (chapterInfo: unknown) => {
  sensors.track('content_view', {
    ...(chapterInfo as object),
  })

  window.ttq?.track('ViewContent', {
    contents: [
      {
        content_id: (chapterInfo as Record<string, string>).resource_id,
      },
    ],
  })
}

export const handleResourceDisplayTrack = (eventData: IResourceDisplay) => {
  sensors.track('resource_display', eventData)
}

export const handleResourceClickTrack = (eventData: IResourceClick) => {
  sensors.track('resource_bit_click', eventData)
}

export interface IReadingButtonShowPayload {
  from: number | ''
}
export const handleReadingButtonShowTrack = (eventData: IReadingButtonShowPayload) => {
  sensors.track('reading_button_show', eventData)
}
